import { render, staticRenderFns } from "./subAccountManagement.vue?vue&type=template&id=40aab8c2&scoped=true"
import script from "./subAccountManagement.vue?vue&type=script&lang=js"
export * from "./subAccountManagement.vue?vue&type=script&lang=js"
import style0 from "./subAccountManagement.vue?vue&type=style&index=0&id=40aab8c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aab8c2",
  null
  
)

export default component.exports